import { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { FilterValues } from "../../../data-model/filterValues";
import { PRIMARY_CARE_TABLE_CMM_FIELDS } from "../constants/primaryCareCmmFields";
import { processFilterData } from "../utils/processFilterData";

export interface PrimaryCareFilterPayload {
  date_from_start?: string;
  date_from_end?: string;
  filters?: {
    patient_mrn?: string[];
    [key: string]: any;
  };
  page: number;
  page_size: number;
  request_id?: string;
  keyword?: string;
  cmm_fields?: string[];
}

export interface UseFilterPayloadReturn {
  filterPayload: PrimaryCareFilterPayload | null;
  setFilterPayload: React.Dispatch<
    React.SetStateAction<PrimaryCareFilterPayload | null>
  >;
}

export const useFilterPayload = (
  validFilters: FilterValues[],
  searchTerm: string,
  initialDataFetchingExecuted: boolean,
  dateFromStart: string,
  dateFromEnd: string,
  pageSize: number = 120,
): UseFilterPayloadReturn => {
  const [filterPayload, setFilterPayload] =
    useState<PrimaryCareFilterPayload | null>(null);

  useEffect(() => {
    if (!initialDataFetchingExecuted) {
      setFilterPayload(null);
    } else {
      const apiFilters = processFilterData(validFilters);

      const payload: PrimaryCareFilterPayload = {
        filters: apiFilters,
        page: 1,
        page_size: pageSize,
        request_id: uuidv4(),
        cmm_fields: [...PRIMARY_CARE_TABLE_CMM_FIELDS],
      };

      // Add keyword if search term exists
      if (searchTerm && searchTerm.trim().length > 0) {
        payload.keyword = searchTerm.trim();
      }

      setFilterPayload(payload);
    }
  }, [
    validFilters,
    searchTerm,
    initialDataFetchingExecuted,
    dateFromStart,
    dateFromEnd,
    pageSize,
  ]);

  return {
    filterPayload,
    setFilterPayload,
  };
};
